export default __webpack_public_path__ + "static/media/Inconsolata-Bold.9909dc4a.eot";